import { cn } from '@/lib/utils';

const colorConfig: Record<string, { dot: string; active: string; activeText: string }> = {
  blue: {
    dot: 'bg-blue-500',
    active: 'bg-blue-50 dark:bg-blue-950/40 border-blue-200 dark:border-blue-800',
    activeText: 'text-blue-700 dark:text-blue-300',
  },
  emerald: {
    dot: 'bg-emerald-500',
    active: 'bg-emerald-50 dark:bg-emerald-950/40 border-emerald-200 dark:border-emerald-800',
    activeText: 'text-emerald-700 dark:text-emerald-300',
  },
  purple: {
    dot: 'bg-purple-500',
    active: 'bg-purple-50 dark:bg-purple-950/40 border-purple-200 dark:border-purple-800',
    activeText: 'text-purple-700 dark:text-purple-300',
  },
  orange: {
    dot: 'bg-orange-500',
    active: 'bg-orange-50 dark:bg-orange-950/40 border-orange-200 dark:border-orange-800',
    activeText: 'text-orange-700 dark:text-orange-300',
  },
  zinc: {
    dot: 'bg-zinc-400',
    active: 'bg-zinc-50 dark:bg-zinc-800 border-zinc-200 dark:border-zinc-700',
    activeText: 'text-zinc-700 dark:text-zinc-300',
  },
};

interface Provider {
  name: string;
  display_name: string;
  color_scheme: string;
}

interface ProviderTabsProps {
  providers: Provider[];
  current: string;
  onChange: (provider: string) => void;
  className?: string;
}

export function ProviderTabs({ providers, current, onChange, className }: ProviderTabsProps) {
  if (providers.length <= 1) return null;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1 rounded-lg bg-zinc-100 dark:bg-zinc-800/60 p-1',
        className
      )}
    >
      {providers.map((p) => {
        const isActive = p.name === current;
        const colors = colorConfig[p.color_scheme] || colorConfig.zinc;

        return (
          <button
            key={p.name}
            onClick={() => onChange(p.name)}
            className={cn(
              'relative flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-all duration-150',
              isActive
                ? cn('border shadow-sm', colors.active, colors.activeText)
                : 'border border-transparent text-zinc-500 dark:text-zinc-400 hover:text-zinc-700 dark:hover:text-zinc-200'
            )}
          >
            <span className={cn('h-2 w-2 rounded-full shrink-0', colors.dot)} />
            {p.display_name}
          </button>
        );
      })}
    </div>
  );
}
